{
  "slug": "iq-distribution",
  "title": "আইসিসি টুয়েন্টি২০ বিশ্বকাপ",
  "description": "বেল বক্ররেখা, গড়, স্ট্যান্ডার্ড ডেভিশন, লেজ এবং বাস্তব মানগুলি আইকিউ এর সাথে সম্পর্কিত।",
  "category": "IQ পরিসংখ্যান",
  "sections": [
    {
      "heading": "অর্থ",
      "paragraphs": [
        "বেল বক্ররেখা, গড়, স্ট্যান্ডার্ড ডেভিশন, লেজ এবং বাস্তব মানগুলি আইকিউ এর সাথে সম্পর্কিত।",
        "ব্যাখ্যা জনসংখ্যা, যন্ত্র, সংস্করণ, বছর, নমুনা, ভাষা এবং পদ্ধতির উপর নির্ভর করে।"
      ]
    },
    {
      "heading": "সার্টিফিকেটগুলো ভালো করে পড়ুন",
      "paragraphs": [
        "প্রতিনিধিত্ব, অনিশ্চয়তা, বর্জন এবং মানগুলো পরিমাপ করা হয়েছে কিনা বা অনুমান করা হয়েছে কিনা তা পরীক্ষা করুন। দশমিক-বহুল রেটিং স্বয়ংক্রিয়ভাবে সঠিক নয়।",
        "গ্রুপ গড়ে উল্লেখযোগ্যভাবে ওভারল্যাপ আছে এবং ব্যক্তি নির্ধারণ করা যায় না।"
      ]
    },
    {
      "heading": "দায়বদ্ধ সমাপ্তি",
      "paragraphs": [
        "স্বচ্ছ প্রাথমিক ডেটাসেট এবং অন্তরকাল পছন্দ করুন। শুধুমাত্র সংযোগ থেকে কারণ দাবি এড়িয়ে চলুন।",
        "ব্যক্তিগতভাবে, উপযুক্ত বয়স ও প্রযুক্তিগত নথিপত্র ব্যবহার করুন।"
      ]
    }
  ],
  "related": ["what-is-the-average-iq", "how-is-iq-measured", "iq-score-ranges-explained"],
  "sources": [
    {
      "label": "ওইসিডি - পিআইএসএ তথ্য এবং পদ্ধতি",
      "url": "https://www.oecd.org/pisa/data/"
    }
  ],
  "faqs": [],
  "summary": "IQ এর সাথে ঘণ্টা বক্ররেখা, গড়, মানদণ্ড বিভ্রাট, লেজ এবং বাস্তব মান সম্পর্কিত। 18 জুলাই 2026."
}
